import React, { useState } from "react";

/**
 * Modale d'ajout d'une pause dans l'horaire d'un événement.
 * Extracted from pages/EventDetail.jsx (refactor Feb 27, 2026).
 */
export default function BreakModal({ event, onSave, onClose }) {
  const [label, setLabel] = useState("Pause repas");
  const [duration, setDuration] = useState(30);
  const [surface, setSurface] = useState("all");
  const surfaces = event.surfaces || 2;

  return (
    <div className="fixed inset-0 z-[90] bg-black/65 backdrop-blur-sm flex items-center justify-center p-4">
      <div className="bg-[var(--surface)] border border-[var(--border-strong)] rounded-2xl p-6 max-w-md w-full shadow-2xl" data-testid="break-modal">
        <div className="label mb-1">Nouvelle pause</div>
        <h3 className="font-serif text-3xl mb-5">Ajouter une pause</h3>
        <Field2 label="Description">
          <input value={label} onChange={(e) => setLabel(e.target.value)} className="input-box" />
        </Field2>
        <Field2 label="Durée (min)">
          <input type="number" value={duration} onChange={(e) => setDuration(e.target.value)} className="input-box" />
        </Field2>
        <Field2 label="Surface">
          <select value={surface} onChange={(e) => setSurface(e.target.value)} className="input-box">
            <option value="all">Toutes les surfaces</option>
            {Array.from({ length: surfaces }, (_, i) => i + 1).map((s) => (
              <option key={s} value={s}>
                Surface #{s}
              </option>
            ))}
          </select>
        </Field2>
        <div className="flex justify-end gap-2 mt-5">
          <button onClick={onClose} className="btn-secondary">
            Annuler
          </button>
          <button onClick={() => onSave(label, duration, surface)} className="btn-primary" data-testid="break-save-btn">
            Ajouter
          </button>
        </div>
      </div>
    </div>
  );
}

function Field2({ label, children }) {
  return (
    <div className="mb-3">
      <label className="label block mb-1.5">{label}</label>
      {children}
    </div>
  );
}
